module.exports = __webpack_public_path__ + "a768e7de/img/menu-icon.5f8facae.svg";